"use client";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import Box from "@mui/material/Box";
import Button, { ButtonProps } from "@mui/material/Button";
import { usePathname } from "next/navigation";
import { styled } from "@mui/material/styles";

import { getUrls } from "@portal/app/_common/lib/urls";
import { useAuthenticatedContext } from "@portal/app/_components/context/AuthenticatedContext";
import { LAYOUT_MOBILE_DESKTOP_RESPONSIVE_BREAKPOINT } from "@portal/app/_components/ui-elements/Layout";
import { usePageContext } from "@portal/app/_components/context/PageContext";

export const PrimaryActionButtons = () => {
  const {
    role: { isSchool, hasAdminRole },
  } = useAuthenticatedContext();
  const { clientLocation } = usePageContext();
  const urls = getUrls();
  const pathname = usePathname();
  const pathBreadcrumb =
    pathname
      ?.split("/")
      .map((_, idx, pathItems) => pathItems.slice(0, idx + 1).join("/"))
      .filter(Boolean) ?? [];

  return (
    <ButtonsContainer>
      <NavPrimaryButton
        href={urls.DreamSearch({ zip: clientLocation.zip })}
        {...(pathBreadcrumb.includes("/explore") && {
          className: "active",
        })}
      >
        {/* <NavIcon icon={faBook} /> */}
        Classes
      </NavPrimaryButton>
      <NavPrimaryButton
        href="https://school.dreambound.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {/* <NavIcon icon={faHandshake} /> */}
        Partner With Us
      </NavPrimaryButton>
      <NavPrimaryButton href={urls.About()}>
        {/* No need for className because this is a Webflow page */}
        {/* <NavIcon icon={faCircleInfo} /> */}
        About
      </NavPrimaryButton>
      <NavPrimaryButton
        href={urls.BlogHome()}
        {...(pathBreadcrumb.includes(urls.BlogHome()) && {
          className: "active",
        })}
      >
        {/* <NavIcon icon={faNewspaper} /> */}
        Blog
      </NavPrimaryButton>
      {isSchool && (
        <NavPrimaryButton href={getUrls("SCHOOL").Dashboard()}>
          {/* <NavIcon icon={faGraduationCap} /> */}
          School Portal
        </NavPrimaryButton>
      )}
      {hasAdminRole && (
        <NavPrimaryButton href={getUrls("ADMIN").Dashboard()}>
          {/* <NavIcon icon={faGear} /> */}
          Admin Portal
        </NavPrimaryButton>
      )}
    </ButtonsContainer>
  );
};
export const NavIcon = (props: FontAwesomeIconProps) => {
  return <FontAwesomeIcon size="xl" {...props} />;
};

export const NavButtonElement = styled(Button)`
  align-self: stretch;

  color: ${({ theme }) => theme.palette.dream.grayDark};
  border-radius: 0.5rem;
  white-space: nowrap;

  display: flex;
  align-items: center;
  transition: 100ms linear background-color;

  ${({ theme }) => theme.breakpoints.up(LAYOUT_MOBILE_DESKTOP_RESPONSIVE_BREAKPOINT)} {
    margin: var(--NavBarDesktopMainVerticalMargin) 0 var(--NavBarDesktopMainVerticalMargin) 0;
    padding: 0 1rem;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  &.active {
    background: ${({ theme }) => theme.palette.dream.grayMedium};
  }
`;

export const NavButton = (props: ButtonProps) => {
  return <NavButtonElement variant="text" classes={{ root: "nav-button" }} {...props} />;
};

export const NavPrimaryButton = styled(NavButton)`
  font-size: 1rem;
  justify-content: start;

  svg {
    margin-right: 0.5em;
  }
` as typeof Button;

const ButtonsContainer = styled(Box)`
  display: flex;

  ${({ theme }) => theme.breakpoints.down(LAYOUT_MOBILE_DESKTOP_RESPONSIVE_BREAKPOINT)} {
    flex-direction: column;

    > .nav-button {
      height: 3rem;
      margin-bottom: 0.75rem;
    }
  }

  ${({ theme }) => theme.breakpoints.up(LAYOUT_MOBILE_DESKTOP_RESPONSIVE_BREAKPOINT)} {
    margin-left: 1rem;
    align-self: stretch;
  }
`;
